module.exports = __webpack_public_path__ + "img/cjwk.9fd5092f.png";